export const getQueryArray = (array: (string | number | boolean)[] | undefined, queryName: string) => {
  if (!array || array?.length === 0) return '';
  return `${queryName}=` + array.join(`&${queryName}=`);
};
